export const DataCollectionType = Object.freeze({
    IGM: "IGM",
    PEMMDB: "PEMMDB"
});